module.exports = "/wwwroot/img/air_quality_report_page.png?ver=843fc5a6";